var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcToiletDoorFold = function SvgIcToiletDoorFold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    fill: "none",
    viewBox: "0 0 33 33"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21.087,
    x: 5.25,
    y: 5.976,
    fill: "#67AEFF",
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.852 9.492a2 2 0 0 1 .719-1.537l4.08-3.4v23.82l-4.08-3.4a2 2 0 0 1-.72-1.537zM22.453 9.492a2 2 0 0 1 .72-1.537l4.08-3.4v23.82l-4.08-3.4a2 2 0 0 1-.72-1.537z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M22.453 9.492a2 2 0 0 0-.72-1.537l-4.079-3.4v23.82l4.08-3.4a2 2 0 0 0 .72-1.537z"
  })));
};
export default SvgIcToiletDoorFold;